var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { accountExportTemplateEntityName, } from '../../../../../backend/features/accounts/shared';
import { useContactManagementTranslation } from '../../../../../ui/hooks';
import { showWizardDialog } from '@juvare/common-form-ui/showWizardDialog';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { getSettings } from '@juvare/platform-sdk-react/ui/features/editable-settings';
import { useStorageClient } from '@juvare/platform-sdk-react/ui/hooks';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Box, IconButton, Radio, Stack, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAccountExportWizardSteps } from '../../hooks/useAccountExportWizardSteps';
import { AccountExportTemplateTablePagination } from './AccountExportTemplateTablePagination';
import { ExportTemplateCard } from './ExportTemplateCard';
export const AccountExportTemplateList = ({ dataTableProps, onEditTemplate, onAfterDeleteTemplate, onAfterEditTemplate, onTemplateChange, }) => {
    const { t } = useContactManagementTranslation();
    const settings = useSelector(getSettings);
    const { selectFieldsStep, columnOrderStep } = useAccountExportWizardSteps();
    const storageClient = useStorageClient(accountExportTemplateEntityName);
    return (React.createElement(Stack, { gap: 2 },
        React.createElement(Stack, { gap: 2 }, dataTableProps.rows.map((field) => {
            var _a, _b, _c;
            const checked = !!((_a = dataTableProps.selectedRowIds) === null || _a === void 0 ? void 0 : _a.includes(field.id));
            const csvPreviewItems = (_c = (_b = field.columns.headerNames) === null || _b === void 0 ? void 0 : _b.map((headerName, index) => ({
                id: `${headerName}-${index}`,
                label: headerName,
                error: settings.accountExport.find((settingField) => settingField.headerName === headerName)
                    ? undefined
                    : 'missing-field',
            }))) !== null && _c !== void 0 ? _c : [];
            const handleSelect = (_, checked) => {
                var _a, _b;
                (_a = dataTableProps.onDeselectAllRows) === null || _a === void 0 ? void 0 : _a.call(dataTableProps);
                (_b = dataTableProps.onRowSelectionChange) === null || _b === void 0 ? void 0 : _b.call(dataTableProps, field, checked);
                onTemplateChange(field.id);
            };
            const handleEditTemplate = () => __awaiter(void 0, void 0, void 0, function* () {
                try {
                    const template = yield storageClient.get(field.id);
                    const defaultFieldIds = template.data.fields
                        .filter(({ headerName }) => settings.accountExport.find((settingField) => settingField.headerName === headerName))
                        .map((field) => `${field.headerName}-${field.type}-${'source' in field ? `${field.source}` : ''}`);
                    onEditTemplate();
                    showWizardDialog({
                        onSubmit: handleUpdateTemplate,
                        steps: [
                            selectFieldsStep({ defaultFieldIds }),
                            columnOrderStep({ disableSaveAsExport: true, templateName: template.data.name }),
                        ],
                        title: t('export.editTemplate'),
                        submitButtonLabel: t('common.save'),
                        maxWidth: 'xl',
                    });
                }
                catch (error) {
                    handleErrorSnackbar(error);
                }
            });
            const handleUpdateTemplate = (_a) => __awaiter(void 0, [_a], void 0, function* ({ sortedFields, name, }) {
                try {
                    yield storageClient.post({
                        id: field.id,
                        action: 'partial-update',
                        data: {
                            fields: sortedFields,
                            name,
                        },
                    });
                    showAlertSnackbar({
                        message: t('export.snackbars.templateEdited'),
                        autoHideDuration: 3000,
                        type: 'success',
                    });
                    onAfterEditTemplate();
                }
                catch (error) {
                    handleErrorSnackbar(error);
                }
            });
            const handleDeleteTemplate = () => __awaiter(void 0, void 0, void 0, function* () {
                showConfirmDialog({
                    title: t('export.deleteTemplate'),
                    confirmLabel: t('common.delete'),
                    content: (React.createElement(Typography, { variant: 'body1', color: themeColors.text.subtle }, t('export.deleteTemplateDescription'))),
                    onConfirm: () => __awaiter(void 0, void 0, void 0, function* () {
                        try {
                            yield storageClient.post({
                                id: field.id,
                                action: 'delete',
                            });
                            showAlertSnackbar({
                                message: t('export.snackbars.templateDeleted'),
                                autoHideDuration: 3000,
                                type: 'success',
                            });
                            onAfterDeleteTemplate();
                        }
                        catch (error) {
                            handleErrorSnackbar(error);
                        }
                    }),
                });
            });
            return (React.createElement(Stack, { key: field.id, direction: 'row', alignItems: 'center', gap: 1 },
                React.createElement(Box, null,
                    React.createElement(Radio, { checked: checked, onChange: handleSelect })),
                React.createElement(Box, { borderRadius: 1, width: '100%', border: `1px solid ${themeColors.border.main}`, sx: {
                        outline: checked ? `2px solid ${themeColors.primary.base}` : undefined,
                    }, overflow: 'scroll' },
                    React.createElement(ExportTemplateCard, { actions: [
                            React.createElement(IconButton, { key: 'edit', onClick: handleEditTemplate },
                                React.createElement(DriveFileRenameOutlineIcon, { htmlColor: themeColors.primary.base })),
                            React.createElement(IconButton, { key: 'delete', onClick: handleDeleteTemplate },
                                React.createElement(DeleteOutlinedIcon, { htmlColor: themeColors.primary.base })),
                        ], name: field.columns.name, csvPreviewItems: csvPreviewItems }))));
        })),
        React.createElement(AccountExportTemplateTablePagination, Object.assign({}, dataTableProps))));
};
